<template>
  <!-- <el-select
        style="width: 100%;"
        v-model="value"
        placeholder="请选择"
        ref="selectBoxRef"
        :popper-append-to-body='false'
    >
        <el-option :value="value" style="height: auto;">
            <el-tree
                :data="orgData"
                :props="defaultProps"
                @node-click="handleEditNodeClick"
                class="tree_box"
            ></el-tree>
        </el-option>
    </el-select>-->
  <el-cascader
    ref="selectBoxRef"
    v-model="val"
    :options="orgData"
    :show-all-levels="false"
    placeholder="请选择所属网格"
    :disabled="disabled"
    clearable
    :props="{ checkStrictly: true }"
    @change="handleEditNodeClick"
  ></el-cascader>
</template>

<script>
// <uploadimg v-model="url"></uploadimg>
import request from "@/utils/request.js"
function noop() {}
export default {
  name: "uploadImg",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label",
      },
      orgData: [],
      val: [],
    }
  },
  props: {
    value: {
      default: [],
    },
    disabled: {
      default: false,
    },
    orgType: {
      default: null,
    },
    onSuccess: {
      type: Function,
      default: noop,
    },
  },
  methods: {
    async findTreelist() {
      var res = await request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: {
          orgType: this.orgType,
        },
      })
      this.orgData = res.content
    },
    handleEditNodeClick(value) {
      let v = value[value.length - 1]
      this.$nextTick((res) => {
        let info = {
          label: this.$refs.selectBoxRef.presentText,
          value: v,
        }
        this.onSuccess(info)
      })

      this.$emit("input", value)
      // this.$refs.selectBoxRef.blur();
    },
  },
  mounted() {},
  updated() {},
  created() {
    this.findTreelist()
    this.val = this.value
  },
  watch: {},
}
</script>
<style lang="less" scoped>
</style>
